/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Booking_Status_CompletedInputs */

const en_rental_booking_status_completed = /** @type {(inputs: Rental_Booking_Status_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stay Completed`)
};

const es_rental_booking_status_completed = /** @type {(inputs: Rental_Booking_Status_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estancia Completada`)
};

const fr_rental_booking_status_completed = /** @type {(inputs: Rental_Booking_Status_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séjour terminé`)
};

const de_rental_booking_status_completed = /** @type {(inputs: Rental_Booking_Status_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufenthalt abgeschlossen`)
};

const id_rental_booking_status_completed = /** @type {(inputs: Rental_Booking_Status_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penginapan Selesai`)
};

/** @type {(inputs: Rental_Booking_Status_CompletedInputs) => LocalizedString} */
const ja_rental_booking_status_completed = en_rental_booking_status_completed;

/** @type {(inputs: Rental_Booking_Status_CompletedInputs) => LocalizedString} */
const zh_rental_booking_status_completed = en_rental_booking_status_completed;

/** @type {(inputs: Rental_Booking_Status_CompletedInputs) => LocalizedString} */
const ar_rental_booking_status_completed = en_rental_booking_status_completed;

/** @type {(inputs: Rental_Booking_Status_CompletedInputs) => LocalizedString} */
const it_rental_booking_status_completed = en_rental_booking_status_completed;

/** @type {(inputs: Rental_Booking_Status_CompletedInputs) => LocalizedString} */
const ru_rental_booking_status_completed = en_rental_booking_status_completed;

/** @type {(inputs: Rental_Booking_Status_CompletedInputs) => LocalizedString} */
const pt_rental_booking_status_completed = en_rental_booking_status_completed;

/** @type {(inputs: Rental_Booking_Status_CompletedInputs) => LocalizedString} */
const ko_rental_booking_status_completed = en_rental_booking_status_completed;

/**
* | output |
* | --- |
* | "Stay Completed" |
*
* @param {Rental_Booking_Status_CompletedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_booking_status_completed = /** @type {((inputs?: Rental_Booking_Status_CompletedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Booking_Status_CompletedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_booking_status_completed(inputs)
	if (locale === "es") return es_rental_booking_status_completed(inputs)
	if (locale === "fr") return fr_rental_booking_status_completed(inputs)
	if (locale === "de") return de_rental_booking_status_completed(inputs)
	if (locale === "ja") return ja_rental_booking_status_completed(inputs)
	if (locale === "zh") return zh_rental_booking_status_completed(inputs)
	if (locale === "ar") return ar_rental_booking_status_completed(inputs)
	if (locale === "id") return id_rental_booking_status_completed(inputs)
	if (locale === "it") return it_rental_booking_status_completed(inputs)
	if (locale === "ru") return ru_rental_booking_status_completed(inputs)
	if (locale === "pt") return pt_rental_booking_status_completed(inputs)
	return ko_rental_booking_status_completed(inputs)
});